import { Link } from 'react-router-dom';
import './index.css';

interface ServicesPricingCTAProps {
  label?: string;
}

const ServicesPricingCTA = ({ label = 'Review Pricing' }: ServicesPricingCTAProps) => (
  <section className="services-pricing-cta" aria-label="Pricing information">
    <div>
      <p className="services-pricing-cta-kicker">Pricing</p>
      <h2>Need rate details before you start?</h2>
      <p>
        See hourly rates, retainer starting points, and notes about third-party costs.
      </p>
    </div>
    <Link className="services-pricing-cta-link" to="/pricing">
      {label}
    </Link>
  </section>
);

export default ServicesPricingCTA;
